/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Export_Pick_DateInputs */

const vi_order_export_pick_date = /** @type {(inputs: Order_Export_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng chọn ngày cần xuất`)
};

/**

* @param {Order_Export_Pick_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_export_pick_date = /** @type {((inputs?: Order_Export_Pick_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Export_Pick_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_export_pick_date(inputs)
});